import { render, staticRenderFns } from "./BusinessLocationDetails.vue?vue&type=template&id=b695857a&scoped=true&"
import script from "./BusinessLocationDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessLocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLocationDetails.vue?vue&type=style&index=0&id=b695857a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b695857a",
  null
  
)

export default component.exports